interface Color {
  50: string;
  100: string;
  200: string;
  300: string;
  400: string;
  500: string;
  600: string;
  700: string;
  800: string;
  900: string;
  A100?: string;
}

export const teal: Color = {
  50: '#DCF2F0',
  100: '#A9DFD8',
  200: '#73CABE',
  300: '#3AB4A4',
  400: '#00A391',
  500: '#00927E',
  600: '#008572',
  700: '#007662',
  800: '#006654',
  900: '#004A38',
};

export const fuchsia: Color = {
  50: '#FAE9F7',
  100: '#F2C8ED',
  200: '#EBA3E3',
  300: '#E27DD7',
  400: '#D95ECD',
  500: '#D043C4',
  600: '#C13EBD',
  700: '#AE36B5',
  800: '#9D31AE',
  900: '#7F28A0',
};

export const green: Color = {
  50: '#E6F5E4',
  100: '#C2E6BD',
  200: '#9AD693',
  300: '#6FC666',
  400: '#4ABA42',
  500: '#17AE13',
  600: '#029F04',
  700: '#008D00',
  800: '#007C00',
  900: '#005E00',
};

export const bluishCyan: Color = {
  50: '#E2F5FE',
  100: '#B5E6FB',
  200: '#84D6F9',
  300: '#56C6F6',
  400: '#36B9F5',
  500: '#20AEF3',
  600: '#1D9FE4',
  700: '#188BD0',
  800: '#167ABC',
  900: '#105A9A',
};

export const yellowOrange: Color = {
  50: '#FEF3E2',
  100: '#FDE0B6',
  200: '#FDCD87',
  300: '#FCB859',
  400: '#FBA939',
  500: '#FB9A23',
  600: '#F78F21',
  700: '#F07F1E',
  800: '#EA701B',
  900: '#E05716',
};

export const pinkishRed: Color = {
  50: '#FFEBF0',
  100: '#FFCCD6',
  200: '#FB969F',
  300: '#F66B79',
  400: '#FF3F56',
  500: '#FF183B',
  600: '#FC003C',
  700: '#EA0034',
  800: '#DD002C',
  900: '#CF001E',
};

export const grey: Color = {
  50: '#F6F6FF',
  100: '#F2F1FF',
  200: '#EBEBF9',
  300: '#CAC9D7',
  400: '#ACACB9',
  500: '#82818F',
  600: '#6D6D7A',
  700: '#4D4D59',
  800: '#2B2B36',
  900: '#21222D',
  A100: '#1D1E26',
};

export const stone: Color = {
  50: '#F8F8F8',
  100: '#EFEFEF',
  200: '#E8E8E8',
  300: '#D9D9D9',
  400: '#D2D2D2',
  500: '#A0A0A0',
  600: '#87888C',
  700: '#2C2D33',
  800: '#1D1E26',
  900: '#171821',
};
